/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type models_CreateInvoiceOverrideRequest = {
    kind: string;
    reason?: string;
    scope: models_CreateInvoiceOverrideRequest.scope;
    valueCents?: number;
};
export namespace models_CreateInvoiceOverrideRequest {
    export enum scope {
        PARENT = 'parent',
        SUBSIDY_OFFICE = 'subsidy_office',
    }
}

